import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaDistributionImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.DISTRIBUTION;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        if (preguntaPadre.min == null) {
            pasoTests = false;
            this.errores.push(`Error de sintaxis en ##Min/Max en la pregunta ${preguntaPadre.idPregunta}`);
        }
        return pasoTests;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.maximo = preguntaPadre.minimo;
        preguntaPadre.minimo = null;
        return preguntas;
    }
}
